import React from 'react';
import { CloseButton } from '../../../../../CommonComponents/OPL/CloseButton/CloseButton';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { Header } from '../../WhatIfs.styles';

interface WhatIfsHeaderProps {
  onClose: () => void;
}

export const WhatIfsHeader = ({ onClose }: WhatIfsHeaderProps) => (
  <Header>
    <Text as="h2" fontSize="h5" fontWeight={600} color="neutral.700">
      What-If...
    </Text>

    <CloseButton onClick={onClose} />
  </Header>
);
